import React, { Fragment } from "react";

// components
import Typography from "../Typography/Typography";

// styled compponents
import { Card, CardIcon, CardTitle, Container } from "./listItemStyle";

export const ListItem = ({ items, title, width }) => {
  return (
    <Fragment>
      <Typography size="16px" weight="bold" space=".5rem">
        {title}
      </Typography>
      <Container>
        {items.map((item) => (
          <Card key={item.id} to={item.path} width={width}>
            <CardIcon color={item.color}>{item.icon}</CardIcon>
            <CardTitle>
              <Typography size="14px" weight="bold">
                {item.name}
              </Typography>
            </CardTitle>
          </Card>
        ))}
      </Container>
    </Fragment>
  );
};
export default ListItem;
